import Vue from 'vue'
import Vuex from 'vuex'
import metaModule from "@/store/modules/meta";

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    title:'上海杉脉电子科技发展有限公司',
    pageCount:8,
    selected:0
  },
  modules: {
    metaModule
  }
})
